import { FelaCSS, FelaCSSWithCustomSelectors, colors } from '@bridebook/ui';

interface IStyles {
  logosWrap: FelaCSSWithCustomSelectors;
  title: FelaCSS;
}

const styles = (): IStyles => ({
  logosWrap: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',

    '& .logo-item': {
      backgroundImage: `url(https://image.bridebook.com/assets/sprites-asseenin.png)`,
      backgroundRepeat: 'no-repeat',
      display: 'block',
      marginRight: 4,

      maxWidthTabletSm: {
        marginLeft: 2,
        marginRigt: 2,
        marginTop: 3,
        marginBottom: 3,
      } as Record<string, FelaCSSWithCustomSelectors>,

      maxWidthMobile: {
        zoom: 0.65,
      },
    },

    '& .bbc': {
      width: '92px',
      height: '27px',
      backgroundPosition: '-5px -5px',
    },

    '& .elle': {
      width: '67px',
      height: '28px',
      backgroundPosition: '-107px -5px',
    },

    '& .mailonline': {
      width: '136px',
      height: '23px',
      backgroundPosition: '-184px -5px',
    },

    '& .metro': {
      width: '91px',
      height: '27px',
      backgroundPosition: '-330px -5px',
    },

    '& .nyt': {
      width: '187px',
      height: '28px',
      backgroundPosition: '-431px -5px',
    },

    '& .stylist': {
      width: '106px',
      height: '22px',
      backgroundPosition: '-628px -5px',
    },

    '& .vogue': {
      width: '97px',
      height: '26px',
      backgroundPosition: '-744px -5px',
    },
  },

  title: {
    fontDefaultSemiBold: 18,
    color: colors.space40,
  },
});

export default styles;
